import { Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="bg-navy pt-40 pb-20 relative overflow-hidden">
    <div className="absolute -right-32 -bottom-32 w-[28rem] h-[28rem] bg-brand/10 rounded-full blur-3xl" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] font-semibold text-brand mb-4">{eyebrow}</p>
        <h1 className="font-display font-bold tracking-tight uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] max-w-3xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 text-white/60 max-w-2xl leading-relaxed">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

export const CTABand = () => (
  <section className="bg-brand-subtle border-t border-brand/20">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 flex flex-wrap items-center justify-between gap-6">
      <Reveal>
        <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl text-navy">
          Ready to get moving?
        </h2>
        <p className="text-slate-600 text-sm mt-1">Talk to a relocation specialist today.</p>
      </Reveal>
      <Reveal delay={0.1} className="flex flex-wrap gap-4">
        <a href="/contact" data-testid="cta-band-quote"
          className="inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white text-sm font-bold uppercase tracking-wide px-7 py-3.5 rounded-sm transition-colors">
          Get a Quote
        </a>
        <a href="tel:+15718509694" data-testid="cta-band-call"
          className="inline-flex items-center gap-2 border border-navy/30 text-navy hover:bg-navy hover:text-white text-sm font-bold uppercase tracking-wide px-7 py-3.5 rounded-sm transition-colors">
          (571) 850-9694
        </a>
      </Reveal>
    </div>
  </section>
);
